import * as Sentry from '@sentry/react';

export function captureError(error: unknown, errorMessage: string): void {
  const isError = error instanceof Error;
  const failedError = new Error(
    `${errorMessage}: ${isError ? error?.message : ''}`,
  );
  failedError.stack = error instanceof Error ? error?.stack : undefined;

  Sentry.captureException(failedError);
}
